import { createPartyRequest } from './helper';
export const postPartyAdvisory = createPartyRequest({
    route: '/party/parties/:partyNo/advisory',
    method: 'post',
    source: 'data',
});
